export default __webpack_public_path__ + "static/image3-f8f83801f2950534489fc3b4e265d45a.jpeg";